import { createContext, useState } from 'react';

const StatsContext = createContext({
  refreshStatsData: false,
  setRefreshStatsData: (setRefreshStatsData) => {}
});

export function StatsContextProvider(props) {

  const [refreshStatsData, setRefreshStatsData] = useState(false)

  const context = {
    refreshStatsData,
    setRefreshStatsData
  };

  return <StatsContext.Provider value={context}>
    {props.children}
  </StatsContext.Provider>
}

export default StatsContext;
